/* eslint-disable react/no-danger */
// Third Party Imports
import React from 'react';

// HomeAway Imports
import { FormInput } from '@homeaway/react-form-components';
import InputTel from '@homeaway/react-input-tel';

// Relative Imports
import DialogBox from '../DialogBox';
import AlertBox from '../Alert/Alert';
import ReCAPTCHA from 'react-google-recaptcha';
import backgroundImage1 from '../../images/intro_img1.svg';
import backgroundImage2 from '../../images/intro_img2.svg';
import './WebFormPage.less';
import {ASTERISK} from '../../utils/constants';
import {getKey} from '../utils/commonUtil';

class WebFormPage extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.triggerEdapPageViewAction();
    }

    getEditAccountFormContents() {
        const {
            translations,
            environment,
            emailVal,
            emailError,
            handleEmailBlur,

            firstNameVal,
            firstNameError,

            lastNameVal,
            lastNameError,

            countryCodeVal,
            phoneNumberVal,
            phoneNumberError,
            handleCountryCodeChange,
            handlePhoneNumberChange,

            numberOfProperty,
            handlePropertyCountChange,
            propertyCountError,
            onPropertyCountBlur,


            companyNameVal,
            companyNameError,


            softwareNameVal,

            handleFormOnchangeHandler,
            handleFieldValOnBlur,
            triggerEdapEventOnFocus,
            triggerEdapEventOnPhoneFocus,
            getInputTel,
            onCaptchaChange,
            setRecaptchaRef,
            serviceError,
            handleAlertDismiss
        } = this.props;

        return (
            <div className="lead-user-form">
                      {
                    (serviceError)
                        ? <div className="alert-container">
                            <div className="alert-wrapper">
                                <div className="alert-panel">
                                    <AlertBox
                                        messageKey={serviceError}
                                        translations={translations}
                                        handleAlertDismiss={handleAlertDismiss}
                                        size={'sm'}
                                    />
                                </div>
                            </div>
                        </div>
                        : null
                }
                <div className="wrapper">
                    <div className="content-col">
                        <FormInput
                            id="emailAddress"
                            className="emailAddress"
                            type="email"
                            name="Email Address"
                            label={translations['ipmob.create_account.label_5']+ASTERISK}
                            value={emailVal}
                            errorMsg={translations[emailError]}
                            onChange={handleFormOnchangeHandler}
                            onBlur={handleEmailBlur}
                            onFocus={triggerEdapEventOnFocus}
                            maxLength="64"
                        />
                    </div>
                </div>
                <div className="wrapper">
                    <div className="content-col">
                        <div className="wrapper">
                            <div className="sub-content-col">
                                <FormInput
                                    id="firstName"
                                    type="text"
                                    name="First name"
                                    label={translations['ipmob.create_account.label_3']+ASTERISK}
                                    value={firstNameVal}
                                    maxLength="64"
                                    onChange={handleFormOnchangeHandler}
                                    errorMsg={translations[firstNameError]}
                                    onBlur={handleFieldValOnBlur}
                                    onFocus={triggerEdapEventOnFocus}
                                />
                            </div>
                            <div className="sub-content-col">
                                <FormInput
                                    id="lastName"
                                    type="text"
                                    name="Last name"
                                    label={translations['ipmob.create_account.label_4']+ASTERISK}
                                    value={lastNameVal}
                                    maxLength="64"
                                    onChange={handleFormOnchangeHandler}
                                    errorMsg={translations[lastNameError]}
                                    onBlur={handleFieldValOnBlur}
                                    onFocus={triggerEdapEventOnFocus}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="wrapper">
                    <div className="sub-content-col phone-number">
                        <InputTel
                            ref={getInputTel}
                            id="phoneNumber"
                            name="Phone"
                            className="phone-number"
                            labels={{ phoneNumber: translations['ipmob.create_account.label_8']+ASTERISK}}
                            phoneNumber={phoneNumberVal}
                            countryCode={countryCodeVal}
                            errorMsg={translations[phoneNumberError]}
                            onPhoneChange={handlePhoneNumberChange}
                            onCountryCodeChange={handleCountryCodeChange}
                            onPhoneBlur={handleFieldValOnBlur}
                            onPhoneFocus={triggerEdapEventOnPhoneFocus}
                        />
                    </div>
                    <div className="sub-content-col">
                        <FormInput
                            id="noOfProperties"
                            type="text"
                            name="Number of properties"
                            label={translations['ipmob.software_details.label_3']+ASTERISK}
                            value={numberOfProperty}
                            onChange={handlePropertyCountChange}
                            errorMsg={translations[propertyCountError]}
                            onFocus={triggerEdapEventOnFocus}
                            onBlur={onPropertyCountBlur}
                            maxLength="6"
                        />
                    </div>
                </div>
                <div className="wrapper">
                    <div className="content-col">
                        <FormInput
                            id="companyName"
                            type="text"
                            name="Company Name"
                            label={translations['ipmob.create_account.label_2']+ASTERISK}
                            value={companyNameVal}
                            maxLength="64"
                            onChange={handleFormOnchangeHandler}
                            onFocus={triggerEdapEventOnFocus}
                            errorMsg={translations[companyNameError]}
                            onBlur={handleFieldValOnBlur}
                        />
                    </div>
                </div>
                <div className="wrapper">
                    <div className="content-col">
                        <FormInput
                            id="softwareName"
                            type="text"
                            name="Software Name"
                            label={translations['ipmob.webform.label_7']}
                            value={softwareNameVal}
                            onChange={handleFormOnchangeHandler}
                            onFocus={triggerEdapEventOnFocus}
                            maxLength="64"
                            autoComplete="off"
                        />
                    </div>
                </div>
                <div className="clearfix"/>
                <div className="wrapper">
                    <div className="content-col-left"/>
                    <div id="captcha-holder" className="content-col-right">
                        <ReCAPTCHA
                            ref ={setRecaptchaRef}
                            sitekey={`${getKey(environment)}`}
                            size="invisible"
                            onChange={onCaptchaChange}
                        />
                    </div>
                </div>
            </div>
        );
    }

    getLeadFormUserInfo() {
        return ({
            editFormHead: this.props.translations['ipmob.webform.heading'],
            editFormBody: this.getEditAccountFormContents()
        });
    }

    render() {
        const {
            translations,
            handleFormSubmit,
            enableButton
        } = this.props;

        let leadformUserInfo = {};
        leadformUserInfo = this.getLeadFormUserInfo();

        return (
            <div id="webformPage" className="webform-page">
                <div className="webform-page-wrapper">
                    <div className="overlay" />
                    <img className="webform-pg-img webform-pg-img-1" src={backgroundImage1()} />
                    <img className="webform-pg-img webform-pg-img-2" src={backgroundImage2()} />
                    <div id="editForm" className='edit-form'>
                        <div className="wrapper">
                            <div className="content-col">
                                <DialogBox
                                    handleSubmit={handleFormSubmit}
                                    actionLabel={translations['ipmob.continue']}
                                    contents={leadformUserInfo.editFormBody}
                                    dialogHeading={leadformUserInfo.editFormHead}
                                    styles={{ width: 663, height: 300, innerPadding: 72, outerPaddingTop: 10, outerPaddingBottom: 10 }}
                                    isButtonDisabled={!enableButton}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="trim-bg-image" />
            </div>
        );
    }
}

export default WebFormPage;
